import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ReactComponent as Icon } from '#web-components/assets/icons/done.svg';

import styles from './DoneIcon.styles';

type DoneIconProps = {
  className?: string;
  title?: string;
};

const useStyles = makeStyles(styles, { name: 'DoneIcon' });

export default function DoneIcon({ className, title }: DoneIconProps) {
  const classes = useStyles();
  return (
    <span className={clsx(classes.root, className)} title={title}>
      <Icon />
    </span>
  );
}
